import axios from 'axios';
import { getBaseUrl, MAX_COUNT } from '../core';

export function getResourceLinks(parameters) {
    const params = { offset: 0, maxCount: MAX_COUNT, ...parameters };
    return axios.get(getBaseUrl('resource_links'), { params });
}